import { render, staticRenderFns } from "./DetallesRecepcion.vue?vue&type=template&id=32dc130e&scoped=true&"
import script from "./DetallesRecepcion.vue?vue&type=script&lang=js&"
export * from "./DetallesRecepcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc130e",
  null
  
)

export default component.exports